import featureFlagStore from './featureFlagStore';
import { SpeakerLabelTransitionEffect } from '@/App/remotion/libs/transitions/types';
import { FeatureFlagKeys } from '@/services/featureFlag';
import { DEFAULT_NAME_FONT_SIZE_PRESET, DEFAULT_TITLE_FONT_SIZE_PRESET } from '@/libs/speakerLabelFontSize';
import { SpeakerLabelTextStyle } from '@/domains/asset';

export const BACKGROUND_COLOR_DEFAULT = '#324bff';

export const TEXT_COLOR_DEFAULT = '#ffffff';

export const OUTLINE_COLOR_DEFAULT = '#000';

export const getSpeakerLabelBorderRadiusDefault = () => {
  const useAnimatedSpeakerCards = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Animated_Speaker_Cards];
  return useAnimatedSpeakerCards ? '1em' : '4px';
};

export const getSpeakerLabelBorderRadiusFull = () => {
  const useAnimatedSpeakerCards = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Animated_Speaker_Cards];
  return useAnimatedSpeakerCards ? '100cqh' : '100px';
};

export const getSpeakerLabelDefaultContainerStyle = () => {
  const useAnimatedSpeakerCards = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Animated_Speaker_Cards];
  return {
    position: 'absolute' as const,
    bottom: '0.7cqw',
    left: '0.7cqw',
    minWidth: useAnimatedSpeakerCards ? undefined : '40cqw',
    maxWidth: useAnimatedSpeakerCards ? '90cqw' : '50cqw',
    alignItems: 'flex-start' as const,
    overflow: 'hidden' as const,
    whiteSpace: 'nowrap' as const,
    lineHeight: 'none' as const,
    backgroundColor: BACKGROUND_COLOR_DEFAULT,
    borderRadius: getSpeakerLabelBorderRadiusDefault(),
    padding: useAnimatedSpeakerCards ? '1cqi 0cqi' : '1cqi',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    zIndex: 10
  };
};

export const getSpeakerLabelDefaultNameStyle = (): SpeakerLabelTextStyle => {
  const useAnimatedSpeakerCards = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Animated_Speaker_Cards];
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSizePreset: useAnimatedSpeakerCards ? DEFAULT_NAME_FONT_SIZE_PRESET : undefined,
    fontSize: useAnimatedSpeakerCards ? undefined : 'max(2.5cqi, 12px)',
    lineHeight: 'none',
    fontFamily: 'inherit',
    maxWidth: '100%',
    color: TEXT_COLOR_DEFAULT
  };
};

export const getSpeakerLabelDefaultTitleStyle = (): SpeakerLabelTextStyle => {
  const useAnimatedSpeakerCards = featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Animated_Speaker_Cards];
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSizePreset: useAnimatedSpeakerCards ? DEFAULT_TITLE_FONT_SIZE_PRESET : undefined,
    fontSize: useAnimatedSpeakerCards ? undefined : 'max(2cqi, 10px)',
    lineHeight: 'none',
    fontFamily: 'inherit',
    maxWidth: '100%',
    color: TEXT_COLOR_DEFAULT
  };
};

export const SPEAKER_LABEL_DEFAULT_TRANSITIONS = {
  in: SpeakerLabelTransitionEffect.None,
  out: SpeakerLabelTransitionEffect.None,
  showAfter: 0,
  hideAfter: undefined,
  showAgainOnNewSpeaker: true,
  duration: 0.3
};
